import { render, staticRenderFns } from "./UpdateScore.vue?vue&type=template&id=6673e7b7&scoped=true&"
import script from "./UpdateScore.vue?vue&type=script&lang=js&"
export * from "./UpdateScore.vue?vue&type=script&lang=js&"
import style0 from "./UpdateScore.vue?vue&type=style&index=0&id=6673e7b7&prod&lang=stylus&scoped=true&"
import style1 from "./UpdateScore.vue?vue&type=style&index=1&id=6673e7b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6673e7b7",
  null
  
)

export default component.exports